import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-pill',
  imports: [],
  templateUrl: './pill.component.html',
  styleUrl: './pill.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PillComponent {
  public color = input<'red' | 'yellow' | 'green' | 'gray' | 'outline-gray'>('gray');
}
